export default __webpack_public_path__ + "384afab1c9ed238e6d224c79e8c849e6.png";